// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as MuiCore from '@material-ui/core';
import UsageIcon from '../images/usageAlert.png';

const styles = theme => ({
    root : {
    },
  });

class Usage extends Component {
    render() {

        const { open, usageNotification, ackFunction, usage, user } = this.props;

        let totalUsage = 0;
        if(user?.usageNotifications && user?.usageNotifications?.length > 0) {
            user.usageNotifications.forEach((usageNotification) => {
                totalUsage += usageNotification.currentUsage;
            });
        }

        return(
            <React.Fragment>
                <MuiCore.Dialog open={open}>
                    <MuiCore.DialogContent>
                        <MuiCore.Grid style={{ textAlign: 'center'}}>
                            <img alt='' height={200} width={'auto'}
                                src={UsageIcon}/>
                            <MuiCore.Typography variant='h5' style={{fontFamily: 'Sofia-bold', color: '#000'}}>{`${totalUsage || usageNotification?.currentUsage} minutes used`}</MuiCore.Typography>
                            <MuiCore.Typography variant='h6' style={{fontFamily: 'Sofia-bold', color: '#000'}}>{`Your plan includes ${usageNotification?.includedMinutes} minutes.`}</MuiCore.Typography>
                            <MuiCore.Typography variant='body1' style={{fontFamily: 'Sofia', color: '#000'}}>{`Your service will continue at your per minute rate.`}</MuiCore.Typography>
                        </MuiCore.Grid>
                    </MuiCore.DialogContent>
                    <MuiCore.DialogActions>
                        <MuiCore.Button onClick={usage}>View Usage</MuiCore.Button>
                        <MuiCore.Button onClick={ackFunction}>Ok</MuiCore.Button>
                    </MuiCore.DialogActions>
                </MuiCore.Dialog>
            </React.Fragment>
        )
        
    }
}

Usage.propTypes = {
    open: PropTypes.bool.isRequired,
    usageNotification: PropTypes.object,
    ackFunction: PropTypes.func.isRequired,
    usage: PropTypes.func.isRequired
}

export default MuiCore.withStyles(styles)(Usage);